import React from "react";
import "./SellerPrivacyPolicy.css";

const SellerPrivacyPolicy = () => {
    return (
        <div className="privacy-policy-wrapper">
            <div className="privacy-policy-container">
                <header className="privacy-header">
                    <h1 className="privacy-app-name">JMI Seller</h1>
                    <p className="privacy-tagline">Privacy Policy</p>
                </header>

                <div className="privacy-content">
                    <div className="last-updated">Last updated: September 17, 2026</div>

                    <section className="privacy-section">
                        <p>
                            JMI Seller ("we," "our," or "us") is committed to protecting your privacy.
                            This Privacy Policy explains how we collect, use, disclose, and safeguard
                            your information when you use our mobile application (the "App").
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>1. Information We Collect</h2>
                        <p>We may collect personal information that you voluntarily provide to us when you register with the App, including:</p>
                        <ul>
                            <li><strong>Account Information:</strong> Full name, email address, phone number, and login credentials.</li>
                            <li><strong>Business Details:</strong> Company name, GST number, business address, and trade license information.</li>
                            <li><strong>Financial Information:</strong> Bank account details, UPI ID, and payment transaction history for processing wholesale orders.</li>
                            <li><strong>Order Information:</strong> Purchase history, order details, and transaction records.</li>
                            <li><strong>Location Data:</strong> For delivery and service area verification, with your explicit permission.</li>
                            <li><strong>Device Information:</strong> Device model, operating system, and app usage data for analytics and support.</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>2. How We Use Your Information</h2>
                        <p>We use the collected information for various purposes, including to:</p>
                        <ul>
                            <li>Provide, operate, and maintain our App</li>
                            <li>Process transactions and send related information</li>
                            <li>Improve, personalize, and expand our App</li>
                            <li>Communicate with you, including customer service</li>
                            <li>Send you updates and promotional materials</li>
                            <li>Monitor and analyze usage and trends</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>3. Data Security</h2>
                        <p>
                            We implement appropriate technical and organizational measures to protect your personal information.
                            However, no method of transmission over the Internet or electronic storage is 100% secure,
                            and we cannot guarantee absolute security.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>4. Third-Party Services</h2>
                        <p>
                            We may employ third-party companies and individuals to facilitate our App,
                            provide services on our behalf, or assist us in analyzing how our App is used.
                            These third parties have access to your personal information only to perform
                            these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>5. Children's Privacy</h2>
                        <p>
                            Our App does not address anyone under the age of 13. We do not knowingly collect
                            personally identifiable information from children under 13. If you are a parent
                            or guardian and you are aware that your child has provided us with personal information,
                            please contact us.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>6. Changes to This Privacy Policy</h2>
                        <p>
                            We may update our Privacy Policy from time to time. We will notify you of any changes
                            by posting the new Privacy Policy on this page and updating the "Last updated" date.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>7. Contact Us</h2>
                        <p>
                            If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at{" "}
                            <a href="mailto:support@jewelmartindia.com" className="contact-link">support@jewelmartindia.com</a>.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>8. Data Deletion Requests</h2>
                        <p>
                            If you wish to delete your account and associated data, please visit our{" "}
                            <a href="https://www.jewelmartindia.com/seller-account-delete" className="contact-link">Account Deletion Page</a>{" "}
                            or contact us directly at{" "}
                            <a href="mailto:support@jewelmartindia.com" className="contact-link">support@jewelmartindia.com</a>.
                        </p>
                    </section>
                </div>

                <footer className="privacy-footer">
                    <p>© {new Date().getFullYear()} JMI Seller. All rights reserved.</p>
                    <p className="footer-note">
                        Protecting your privacy is our priority.
                    </p>
                </footer>
            </div>
        </div>
    );
};

export default SellerPrivacyPolicy;